module.exports = __webpack_public_path__ + "static/media/excel.76f21e8a.png";